import React, {Component} from "react";


class ButtonSubmitSearch extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <button type="submit" className="coreBlockItem-typeSubmitSearch"
                    name="BLOCK_ITEM_SUBMIT_ID"
                    value={this.props.blockItem.id}
                    style={JSON.parse(!(this.props.blockItem.inputCss) ? "{}" :this.props.blockItem.inputCss)}
            >{this.props.blockItem.label}</button>
        );
    }
}

export default ButtonSubmitSearch;